'use client'

import { NextIntlClientProvider } from 'next-intl'
import { useLayoutEffect, useState } from 'react'
import { useLocaleStore } from '@/stores/locale-store'
import { useLocalisation } from '@/utils/localisation/useLocalisation'

const LocalisationProvider = ({ children }: { children: React.ReactNode }) => {
  const { defaultLocale } = useLocalisation()
  const locale = useLocaleStore((state) => state.locale)
  const [messages, setMessages] = useState()

  useLayoutEffect(() => {
    import(`../translations/${locale || defaultLocale}.json`)
      .then((data) => {
        setMessages(data)
      })
      .catch((error) => console.error("Couldn't load localisation data:", error))
  }, [locale, defaultLocale])

  if (!messages) return null

  return (
    <NextIntlClientProvider locale={locale} messages={messages}>
      {children}
    </NextIntlClientProvider>
  )
}
export default LocalisationProvider
